import React from "react";
import CustomPrintOutInvoice from "../../../../../partials/content/CustomPrintOutInvoice";
const InvoicePrintOut = ({ invoice }) => {
  return (
    <React.Fragment>
      <CustomPrintOutInvoice invoiceID={invoice.ID} />
    </React.Fragment>
  );
};

export default InvoicePrintOut;
